export interface CustomerExperienceCallDashboardResponse {
    callsMade: number;
    callsAnswered: number;
    callsAnsweredPercentage: number;
    callsAppointmentBooked: number;
    callsAppointmentBookedPercentage: number;
    callsUnableToContact: number;
    callsUnableToContactPercentage: number;
}

export function createCustomerExperienceCallDashboardResponse(): CustomerExperienceCallDashboardResponse {
    return {
        callsMade: 0,
        callsAnswered: 0,
        callsAnsweredPercentage: 0,
        callsAppointmentBooked: 0,
        callsAppointmentBookedPercentage: 0,
        callsUnableToContact: 0,
        callsUnableToContactPercentage: 0,
    };
}
